import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "survey-item fade-in"
}
const _hoisted_2 = { class: "is-justify-content-center is-flex" }
const _hoisted_3 = { class: "p-4 has-text-center is-size-3-desktop is-size-4-touch survey-subtitle" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", { class: "is-hidden-desktop" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", { class: "is-hidden-desktop" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("です。 ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "is-justify-content-center has-background-light" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column font-preview-detail is-justify-content-center is-size-2-desktop is-size-3-touch" }, [
    /*#__PURE__*/_createTextVNode(" あいうえお　アイウエオ　春夏秋冬"),
    /*#__PURE__*/_createElementVNode("span", { class: "is-hidden-touch" }, "　"),
    /*#__PURE__*/_createElementVNode("br", { class: "is-hidden-desktop" }),
    /*#__PURE__*/_createTextVNode("ABCDE, abcde. 12345 ")
  ])
], -1)
const _hoisted_8 = { class: "is-justify-content-center is-flex is-flex-direction-column" }
const _hoisted_9 = { class: "p-4 has-text-center is-size-3-desktop is-size-4-touch survey-subtitle" }
const _hoisted_10 = { class: "p-4 has-text-center is-size-5 survey-subtitle" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.selectedFontIntroduceWord), 1),
            _hoisted_4,
            _createTextVNode("｢" + _toDisplayString(_ctx.selectedFontName) + "｣", 1),
            _hoisted_5,
            _hoisted_6
          ])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.subtitleWord1), 1),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.subtitleWord2), 1)
        ]),
        _createElementVNode("button", {
          class: "button is-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
          disabled: _ctx.isWhiteout
        }, [
          _createElementVNode("text", null, _toDisplayString(_ctx.nextPageButtonWord), 1)
        ], 8, _hoisted_11)
      ]))
    : _createCommentVNode("", true)
}